import {
	AnnouncementActions,
	AnnouncementActionTypes
} from "@/Actions/Announcement";
import { Announcement } from "@/Contracts";
import { Reducer } from "redux";

export interface AnnouncementState {
	readonly announcement: Announcement | null;
}

export const initialAnnouncementState: AnnouncementState = {
	announcement: null
};

export const AnnouncementReducer: Reducer<
	AnnouncementState,
	AnnouncementActions
> = (
	state: AnnouncementState = initialAnnouncementState,
	action: AnnouncementActions
): AnnouncementState => {
	switch (action.type) {
		case AnnouncementActionTypes.GET_ANNOUNCEMENT:
			return {
				...state,
				announcement: action.announcement
			};
		default:
			return state;
	}
};

export default AnnouncementReducer;
